(function() {
    PortalGrid.$inject = ['$scope', '$http', '$location', '$q', '__env', 'toastr', 'httpService', 'readCookie', '$log'];

    angular
    	.module('app')
    	.component('portalGridComponent', {
    		templateUrl: 'modules/portals/components/portalGrid/portalGrid.html',
    		controller: PortalGrid
    	});

    /**
     * Functionality for the portal grid
     *
     * @class PortalGrid
     * @param { service } $scope - The scope of the controller.
     * @param { service } $http - The Angular $http service.
     * @param { service } $location - The Angular $location service.
     * @param { service } __env - The environment configuration.
     * @param { service } toastr - The third party toaster service.
     * @param { service } httpService - The service to send http calls.
     * @param { service } $log - The service to log to console (or to file if needed)
     */
    function PortalGrid($scope, $http, $location, $q, __env, toastr, httpService, readCookie, $log){
    	///////////////////////////////////////////////////////////////////////////
    	// Members
    	///////////////////////////////////////////////////////////////////////////	gi

    	$scope.pageTitle = 'Portal Management Portal';
    	$scope.showCheckbox = true;
    	$scope.pagePermissions = {};

    	var perms = $scope.$parent.$ctrl.permissions.data;
    	$scope.portalTypes = $scope.$parent.$ctrl.portalTypes;

    	// rewrite the permissions array to be easily checked
    	for (var i = 0; i < perms.length; i++){
    		$scope.pagePermissions[perms[i]] = true;
    	}

    	// PORTAL GRID SETUP ---------------------------------------------------------------//
        // columns for the portal table
        var portalColumns = [
    					        {
    					            field: 'portalName',
    					            title: 'Portal Name',
    					            width: '50px'
    					        },
    					        {
    				        		field: 'baseUri',
    					            title: 'Portal URI',
    					            width: '90px'
    					        },
    					        {
    				        		field: 'homePageRelativeUri',
    					            title: 'Relative URI',
    					            width: '50px'
    					        },
                                {
                                    field: 'hostName',
                                    title: 'Host Name',
                                    width: '75px'
                                },
    					        {
    					        	field: 'portalTypeId',
    					        	title: 'Portal Type',
    					        	width: '50px',
    					        	editor: portalTypeEditor,
    					        	filterable: false,
    					        	template: function(dataItem) {
        								return $.grep($scope.portalTypes, function(e){ return e.portalTypeId == dataItem.portalTypeId; }).pop().portalTypeName;
    					        	}
    					        },
    					        {
    				        		field: 'portalToken',
    					            title: 'Portal Token',
    					            width: '100px'
    					        }
    				        ];

        // check the write permission before giving edit buttons
        if($scope.pagePermissions.write) {
        	portalColumns.push({
    					        	command: ['edit','destroy'],
    					        	title: '&nbsp;',
    	        					width: '70px'
    					        });
        }

        // kendo model for portals
        var portalModel = { id: 'portalId',
    						fields : {
    							'selectPortals': { editable: false },
    							'portalName': { type: 'string' },
    							'baseUri': { type: 'string' },
    							'homePageRelativeUri': { type: 'string' },
                                'hostName': { type: 'string' },
    							'portalToken': { type: 'string', editable: false },
    							'portalTypeId': {defaultValue: 1}
    						}};



    	// kendo grid options for the Portal grid
        $scope.portalOptions = {
            columnMenu: false,
            columns: portalColumns,
            detailInit: function(e){ $scope.detailInit(e); },
            editable: 'popup',
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,
            pageable: true,
            remove: deleteEvent,
            save: saveEvent,
            scrollable: true,
            selectable: 'multiple',
            sortable: true
        };

        if($scope.pagePermissions.write) {
        	$scope.portalOptions.toolbar = [
    	       		{ template: kendo.template($('#userSearch').html()) }
    	   		];

    	}

        // kendo data source for the Portal Grid
    	$scope.portalSource = {
    		type: 'aspnetmvc-ajax',
            error: readError,
    		transport: {
    			read: {
    				type: 'get',
    				contentType: 'application/json',
    				url: __env.apiBaseUrlPortal  + 'portals/paged/kendo',
    				beforeSend: function(req) {
						req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
						req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
    		       },
    			},

    		},
    		schema: {
                data: 'data',
                total: 'total',
                model: portalModel,
            },
            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: {
                field: 'portalName',
                dir: 'asc'
            }
    	};
    	// END PORTAL GRID SETUP ----------------------------------------------------------//


    	// USER GRID SETUP ---------------------------------------------------------------//
    	// user grid columns
    	var userColumns = [

    	        {
    	            field: 'email',
    	            title: 'Email',
                    editable: false,
    	            width: '100px',
    	        },
    	        {
    	        	field: 'isEmailConfirmed',
    	        	title: 'Email Confirmed',
    	        	width: '35px',
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" #=(isEmailConfirmed) ? "checked" : ""# disabled/>'
    	        },
    	        {
    	        	field: 'lastPasswordChangeDate',
    	        	title: 'Last Password Change',
                    editable: false,
    	        	width: '50px',
    	        	template: '#= lastPasswordChangeDate != null ? kendo.toString(kendo.parseDate(lastPasswordChangeDate, "yyyy-MM-dd"), "yyyy-M-d h:mm tt") : ""#'
    	        },
    	        {
    	        	field: 'mustChangePassword',
    	        	title: 'Force Password Change',
    	        	width: '35px',
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" #=(mustChangePassword) ? "checked" : ""# disabled/>'
    	        },
    	        {
    	        	field: 'isLockoutEnabled',
    	        	title: 'Locked Out',
    	        	width: '35px',
                    groupable: false,
                    filterable: false,
                    template: '<input type="checkbox" #=(isLockoutEnabled) ? "checked" : ""# disabled/>'
    	        },
    	        {
    	        	field: 'lockoutEndDateUtc',
    	        	title: 'Locked Until (UTC)',
    	        	width: '50px',
                    editable: false,
    	        	template: '#= lockoutEndDateUtc != null ? kendo.toString(kendo.parseDate(lockoutEndDateUtc, "yyyy-MM-dd"), "yyyy-M-d h:mm tt") : ""#'
    	        },
    	        {
    	        	field: 'deactivated',
					title: 'User Status',
					attributes:{ class:'center' },
    	        	width: '40px',
    	        	template: '#= deactivated ? "Deactivated" : "Active"#'
    	        }
    	    ];

            if($scope.pagePermissions.write) {
                userColumns.push({
                                command: [{ name: 'destroy', text: 'Remove' }],
                                title: '&nbsp;',
                                width: '40px'
                            });
        }

        // model kendo uses to bind the data to the grid
		var userModel = {
			id: 'userId',
			fields: {
				'email': { type: 'string' },
				'active': { type: 'boolean' },
				'isEmailConfirmed': { type: 'boolean' },
				'lastPasswordChangeDate': { type: 'date' },
				'mustChangePassword': { type: 'boolean' },
				'isLockoutEnabled': { type: 'boolean' },
				'lockoutEndDateUtc': { type: 'date' },
				'deactivated': { type: 'boolean' }
			}
		};

    	$scope.userSource = {
            serverFiltering: true,
            serverPaging: true,
            pageSize: 20,
            transport: {
                read: {
    				type: 'post',
    				contentType: 'application/json',
    				url: __env.apiBaseUrlPortal  + 'users/startswith/',
    				beforeSend: function(req) {
						req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
						req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
    		       },
    			},
    			parameterMap: function(options, operation) {

    				if(operation == 'read') {

    					return JSON.stringify(options);
    				}
    			}
            }

        };

        // END USER GRID SETUP -----------------------------------------------------------//


    	 // kendo multiselect options for the portal dropdown
        $scope.userSearchOptions = {
    		placeholder: 'Select User...',
            dataTextField: 'email',
            dataValueField: 'userId',
            valuePrimitive: false,
            autoBind: false,

    	};

    	///////////////////////////////////////////////////////////////////////////
    	// Functions
    	///////////////////////////////////////////////////////////////////////////

    	$scope.addNewPortal = function() {
    		$scope.portalGrid.addRow();
    	};

    	/**
         * handles delete event for the portal grid.
         *
         * @function
         * @param { event } e - delete row event
         */
    	function deleteEvent(e) {
    		e.preventDefault();

    		$scope.deletePortal(e.model.portalId);
    	}

    	function portalTypeEditor(container, options) {
    		$('<input required name="' + options.field + '"/>')
                            .appendTo(container)
                            .kendoDropDownList({
                                autoBind: false,
                                dataTextField: 'portalTypeName',
                                dataValueField: 'portalTypeId',
                                dataSource: $scope.portalTypes
                            });
    	}

    	/**
         * handles read error event for the portal grid.
         *
         * @function
         * @param { event } e - read error event
         */
    	function readError(e) {
    		toastr.error('Grid data could not be retrieved. Please report this to Site Administrator.');
    	}

    	function removeUser(e) {
    		e.preventDefault();

    		$scope.removeUser(e.model, e);
    	}

    	/**
         * handles save event for the portal grid.
         *
         * @function
         * @param { event } e - save row event
         */
    	function saveEvent(e) {

    		// stop kendo from being annoying
    		e.preventDefault();

    		if(e.model.portalId > 0) {

    			// portals with an id should be updated
    			$scope.updatePortal(e.model);
    		} else {
    			e.model.portalId = 0;

    			// portals without an id should be added
    			$scope.addPortal(e.model);
    		}
    	}

    	/**
         * Prepares the http request for adding a new portal and handles callback.
         * On sucess, refreshes the kendo grid
         *
         * @function
         * @param { obj } portal - portal object to be added
         */
    	$scope.addPortal = function(portal) {

    		delete portal.portalToken;
    		delete portal.selectPortals;

            var url = __env.apiBaseUrlPortal  + 'portals/';
    		var type = 'post';
    		var data = portal;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Portal successfully added');
    				$scope.portalGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('Portal could not be added');
                    var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;

                    $log.error(message);
    				$scope.portalGrid.dataSource.read();
    			});

        };

        /**
         * Prepares the http request for adding a new user
         * to selected portals and handles callback
         *
         * @function
         */
        $scope.addUserToPortals = function(){
        	// get selected rows
        	var rows = $scope.portalGrid.select();

        	// there can be only one user, so get the first
        	var userIds = [$scope.user[0].userId];

        	var portals = [];

        	// loop through and put the ids in an array
        	for (var i = 0; i < rows.length; i++) {

        		portals.push($scope.portalGrid.dataItem(rows[i]).portalId);
        	}

        	var data = {'userIds': userIds, 'portalIds': portals };
        	var type = 'post';
        	var url = __env.apiBaseUrlPortal  + 'userportals/';

        	httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('User portals have been added for users');
    				$scope.portalGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The portals could not be added to the requested users');
                     var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.portalGrid.dataSource.read();
    			});
        };


    	/**
         * Prepares the http request for deleting a portal and handles callback.
         *
         * @function
         * @param { int } portalId - id of portal to be deleted
         */
        $scope.deletePortal = function(portalId) {

        	var url = __env.apiBaseUrlPortal  + 'portals/' + portalId;
    		var type = 'delete';
    		var data = '';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Portal successfully deleted');
    				$scope.portalGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The Portal could not be deleted');
                    var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.portalGrid.dataSource.read();
    			});

    	};

    	/**
         * Click event that opens an inner grid displaying users that have access to the
         * given portal.
         *
         * @function
         * @param { event } e - open grid row event
         */
        $scope.detailInit = function(e) {

        	$('<div id="user-' + e.data.uid + '"/>').appendTo(e.detailCell).kendoGrid({
        		//error: function(e) {debugger;},
        		dataSource: {
        			type: 'aspnetmvc-ajax',
    				transport: {
    					read: {
    						type: 'get',
    						contentType: 'application/json',
    						url: __env.apiBaseUrlUser + 'userportals/' + e.data.portalId + '/paged/users',
    						beforeSend: function(req) {
								req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
								req.setRequestHeader('Authorization','Bearer ' + readCookie.getByName(__env.authCookieName));
    				       },
    					},
    				},
    				schema: {
    		            data: 'data',
    		            total: 'total',
    		            model: userModel
    		        },
    		        pageSize: 20,
    		        serverPaging: true,
    		        serverSorting: true,
    		        serverFiltering: true,
    		        sort: {
    		            field: 'email',
    		            dir: 'asc'
    		        }
    			},
    	        columns: userColumns,
    	        editable: true,
    	        filterable: {
    	            extra: false,
    	            operators: {
    	                string: {
    	                    contains: 'Contains',
    	                    eq: 'Is equal to'
    	                }
    	            }
    	        },
    	        groupable: false,
    	        pageable: true,
    	        remove: removeUser,
    	        scrollable: true,
    	        sortable: true
        	});
        };




        /**
         * Sets up http request to remove a user from a given portal.
         * Handles callbacks
         *
         * @function
         * @param { event } e - kendo click event
         * @param { obj } user - user object
         */
        $scope.removeUser = function(user, e) {
        	// get the master row for the detail
        	var parentRow = e.row.closest('.k-detail-row').prev();

        	// get the coresponding user
        	var portal = $scope.portalGrid.dataItem(parentRow);

        	var grid = $('#user-' + portal.uid).data('kendoGrid');

        	// get the data to be sent
        	var data = {'portalTokens': [portal.portalToken]};

        	var url = __env.apiBaseUrlPortal + 'userportals/' + encodeURI(user.email) + '/portals';
    		var type = 'delete';
    		var data = data;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('User successfully removed from portal');
    				grid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The user could not be removed from portal');
                    var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				grid.dataSource.read();
    			});
        };

        /**
    	 * Binds the kendo selected values to the checkbox
    	 * @function
    	 * e {event} - click event for the checkbox
    	 */
    	$scope.selectPortals = function(e) {
    		var grid = $scope.portalGrid;

    		var element = $(e.currentTarget);

    		var checked = element.is(':checked'),
              	row = element.closest('tr'),
              	dataItem = grid.dataItem(row);

    		if (checked) {
    			row.addClass('k-state-selected');
    		} else {
    			row.removeClass('k-state-selected');
    		}
    	};


    	/**
         * Prepares the http request for updating a user and handles callbacks.
         *
         * @function
         * @param { obj } portal - portal object
         */
        $scope.updatePortal = function(portal) {
        	var url = __env.apiBaseUrlPortal + 'portals/';
    		var type = 'put';
    		var data = portal;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Portal successfully updated');
    				$scope.portalGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The Portal could not be updated');
                    var message = 'Status: ' + e.status +
                                    '; Error:' + e.statusText;


                    $log.error(message);
    				$scope.portalGrid.dataSource.read();
    			});
        };


    };
})();
